<template>
  <v-card class="auth-content elevation-12 pa-8" max-width="612">
    <v-card-text>
      <div class="text-h5-nk mb-5">{{$t('accountRecoveryFinish.title')}}</div>
      <v-progress-linear v-if="hashCheckInProgress" indeterminate></v-progress-linear>
      <div v-if="errorBlockVisible">
          <div class="info-text text-subtitle-1">
            {{ hashCheckError }}
          </div>
      </div>
      <div v-if="recoveryFormVisible">
        <v-alert text color="light-blue n100">
          <div class="info-text">
            {{ $t('accountRecoveryFinish.hint.enterPasswordForAccount') }}
          </div>
        </v-alert>
        <v-form v-model="passwordFormValid">
          <v-text-field disabled :value="userInfo.email"
                        outlined
                        dense>
            <template slot="prepend-inner">
              <v-icon>$vuetify.icons.person</v-icon>
            </template>
          </v-text-field>
          <v-text-field ref="password" :errorMessages="passwordErrors"
                        outlined
                        dense
                        :disabled="recoveryInProgress" v-model="password"
                        name="password" :placeholder="$t('accountRecoveryFinish.fields.password.label')" id="password"
                        type="password" autocomplete="current-password" counter maxlength="72" :rules="passwordRules"
                        @input="resetBackendValidationErrors('password')">
            <template slot="prepend-inner">
              <v-icon>$vuetify.icons.key</v-icon>
            </template>
          </v-text-field>
          <v-text-field ref="confirmPassword" :errorMessages="passwordErrors"
                        outlined
                        dense
                        :disabled="recoveryInProgress" v-model="confirmPassword"
                        name="confirmPassword" :placeholder="$t('accountRecoveryFinish.fields.confirmPassword.label')" id="password"
                        type="password" counter maxlength="72" :rules="confirmPasswordRules">
            <template slot="prepend-inner">
              <v-icon>$vuetify.icons.key</v-icon>
            </template>
          </v-text-field>
        </v-form>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn color="light-blue-nk n700" class="white--text" to="/account-recovery" v-if="errorBlockVisible">
        {{ $t('accountRecoveryFinish.buttons.tryAgain.title') }}
      </v-btn>
      <v-btn color="light-blue-nk n700" class="white--text ml-2"
             :disabled="!passwordFormValid || recoveryInProgress" :loading="recoveryInProgress"
             @click="handleRecoveryButtonClick">
        {{ $t('accountRecoveryFinish.buttons.restore.title') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import api from '../api'
import {extractUserErrorMessage, extractValidationErrors} from 'js-core/helpers/api'

export default {
  name: "AccountRecoveryFinish",
  data() {
    return {
      hash: null,
      hashCheckInProgress: false,
      hashCheckError: null,
      userInfo: null,
      passwordFormValid: false,
      password: null,
      confirmPassword: null,
      recoveryInProgress: false,
      backendValidationErrors: {},
      passwordRules: [
        v => !!v || this.$i18n.t('accountRecoveryFinish.validation.noPassword'),
        v => (v && _.toString(v).length <= 72) || this.$i18n.t('accountRecoveryFinish.validation.passwordMaxLength'),
        v => (v && _.toString(v).length >= 8) || this.$i18n.t('accountRecoveryFinish.validation.passwordMinLength')
      ],
      confirmPasswordRules: [
        v => !!v || this.$i18n.t('accountRecoveryFinish.validation.noConfirmPassword'),
        v => (v && _.toString(v).length <= 72) || this.$i18n.t('accountRecoveryFinish.validation.passwordMaxLength'),
        v => (v && _.toString(v).length >= 8) || this.$i18n.t('accountRecoveryFinish.validation.passwordMinLength'),
        (v) => {
          if (this.password !== v) {
            return this.$i18n.t('accountRecoveryFinish.validation.passwordsMismatch')
          }
          return true
        }
      ],
    }
  },
  mounted() {
    this.hash = _.get(this.$route, ['params', 'hash'], null)

    this.checkAccountRecovery(this.hash)
  },
  computed: {
    errorBlockVisible() {
      return this.hashCheckError && !this.hashCheckInProgress
    },
    recoveryFormVisible() {
      return this.userInfo !== null
    },
    passwordErrors() {
      return _.get(this.backendValidationErrors, 'password', null)
    },
  },
  methods: {
    async checkAccountRecovery(hash) {
      this.userInfo = null
      this.hashCheckInProgress = true
      try {
        const result = await api.checkAccountRecovery(hash)
        this.userInfo = _.get(result, ['user'], null)
      } catch (e) {
        this.hashCheckError = extractUserErrorMessage(e, this.$i18n.t("accountRecoveryFinish.errors.unableRecovery"))
      }

      this.hashCheckInProgress = false
    },
    async handleRecoveryButtonClick() {
      this.recoveryInProgress = true

      try {
        await api.finishAccountRecovery(this.hash, this.password, this.$i18n.locale)
        this.$snotify.success(this.$i18n.t("accountRecoveryFinish.notification.accountRecovered"))
        this.$router.push('/login')
      } catch (e) {
        this.backendValidationErrors = extractValidationErrors(e)

        if (this.backendValidationErrors === null) {
          this.$snotify.error(extractUserErrorMessage(e, this.$i18n.t("accountRecoveryFinish.errors.unableRecovery")))
        }
      }

      this.recoveryInProgress = false
    },
    resetBackendValidationErrors(field) {
      if (!this.backendValidationErrors[field]) {
        return
      }

      this.backendValidationErrors[field] = null
    }
  }
}
</script>
